(function () {
  function activateStep(loop, index) {
    const buttons = loop.querySelectorAll('[data-ai-step]');
    const panels = loop.querySelectorAll('[data-ai-step-panel]');

    buttons.forEach((button) => {
      const isActive = button.getAttribute('data-ai-step') === index;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach((panel) => {
      const isActive = panel.getAttribute('data-ai-step-panel') === index;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }

  function initAiTechnology(root) {
    root.querySelectorAll('[data-ai-loop]').forEach((loop) => {
      if (loop.dataset.aiLoopReady === 'true') return;

      loop.dataset.aiLoopReady = 'true';
      loop.querySelectorAll('[data-ai-step]').forEach((button) => {
        button.addEventListener('click', () => {
          activateStep(loop, button.getAttribute('data-ai-step'));
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAiTechnology(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initAiTechnology(event.target);
  });
})();
